import * as React from "react";
import styles from "./section2.module.scss";
import Couple from "@public/assets/images/vendors-section.png";
import Image from "next/image";
import Seamless from "@public/assets/icons/seamless.svg";
import Booking from "@public/assets/icons/booking.svg";
import Showcase from "@public/assets/icons/service.svg";
import Campaign from "@public/assets/icons/campaign.svg";
import VendorsBlock from "@components/VendorsBlock";
import { gsap } from "gsap";

const blocks = [
  {
    name: "Seamless experience",
    description:
      "Effective flow to give your customers a hassle free experience",
    icon: <Seamless className={styles["section2__right__icon"]} />,
  },
  {
    name: "Effective booking system",
    description: "Manage your availability and bookings in one place",
    icon: <Booking className={styles["section2__right__icon"]} />,
  },
  {
    name: "Service Showcase",
    description:
      "Market your service to the right people who are in need of it",
    icon: <Showcase className={styles["section2__right__icon"]} />,
  },
  {
    name: "Easy Ads Campaigns",
    description: "Boost your service and grow your brand with our targeted ads",
    icon: <Campaign className={styles["section2__right__icon"]} />,
  },
];

const VendorsSection2: React.FC = () => {
  const [selectedBlock, setSelectedBlock] = React.useState(1);
  let leftRef = React.useRef<Array<HTMLDivElement | null>>([]);
  let rightRef = React.useRef<Array<HTMLDivElement | null>>([]);

  React.useEffect(() => {
    let currentLeftRef = leftRef.current;
    let currentRightRef = rightRef.current;

    gsap.defaults({ ease: "Power4.out" });

    let tl1 = gsap.timeline({
      scrollTrigger: {
        trigger: currentRightRef,
        start: "top 60%",
        // markers: process.env.NODE_ENV === "development" ? true : false
      },
    });

    let tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: currentLeftRef,
        start: "top 60%",
        // markers: process.env.NODE_ENV === "development" ? true : false
      },
    });

    tl1.staggerFromTo(
      currentRightRef,
      1,
      { autoAlpha: 0, y: 40 },
      { autoAlpha: 1, y: 0 },
      0.1
    );

    tl2.staggerFromTo(
      currentLeftRef,
      1,
      { autoAlpha: 0, y: 40 },
      { autoAlpha: 1, y: 0 },
      0.1
    );
  }, []);
  return (
    <section className={styles["section2"]}>
      <div className={styles["section2__container"]}>
        <div className={styles["section2__left"]}>
          <div
            className={styles["section2__left__under"]}
            ref={(element) => {
              leftRef.current[0] = element;
            }}
          ></div>
          <div
            ref={(element) => {
              leftRef.current[1] = element;
            }}
            className={styles["section2__left__on-top"]}
            data-scroll
            data-scroll-speed="3"
          >
            <Image
              src={Couple}
              alt="a couple in the rain"
              placeholder="blur"
              quality={100}
              height={602.69}
              width={564.29}
            />
          </div>
        </div>

        <div className={styles["section2__right"]}>
          <div className={styles["section2__hidden"]}>
            <h3
              ref={(element) => {
                rightRef.current[0] = element;
              }}
              className={styles["section2__right__heading"]}
            >
              Vendors business made easy
            </h3>
          </div>
          <div className={styles["section2__hidden"]}>
            <p
              ref={(element) => {
                rightRef.current[1] = element;
              }}
              className={styles["section2__right__body"]}
            >
              User friendly experience to give your buisness the online presence
              it deserves.
            </p>
          </div>

          <div className={styles["section2__right__stack"]}>
            {blocks.map((item, idx) => (
              <div
                key={`block ${idx}`}
                ref={(element) => {
                  rightRef.current[idx + 2] = element;
                }}
                className={styles["section2__hidden"]}
              >
                <VendorsBlock
                  icon={item.icon}
                  description={item.description}
                  selectedBlock={selectedBlock}
                  setSelectedBlock={setSelectedBlock}
                  name={item.name}
                  id={idx + 1}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VendorsSection2;
